import {
  ITennisResults
} from "@sky-it-livedata/livedata-sports-design-system";
import { isNotEmptyArray } from "@sky-it-livedata-libraries/livedata-commons";
import { ResultsSubscriptionData } from "../types";
import { composeEmptyPlayers } from "../results-utils";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { UpdateSdapiResultsWidgetInputSchema } from "appsync";

const isValidObject = (obj: ResultsSubscriptionData) =>
  Boolean(obj?.data?.onUpdateSdapiResultsWidgetByDay);

export const transformSubscription = (obj: ResultsSubscriptionData): ITennisResults => {
  if (isValidObject(obj)) {
    UpdateSdapiResultsWidgetInputSchema().parse(obj.data.onUpdateSdapiResultsWidgetByDay, {reportInput: true});
    const { categoryName, date, matches } = obj?.data?.onUpdateSdapiResultsWidgetByDay;

    return {
      categoryName,
      date,
      matches: matches?.map((match) => {
        return {
          ...match,
          firstPosition: {
            ...match?.firstPosition,
            players: isNotEmptyArray(match?.firstPosition?.players) ? match?.firstPosition?.players : composeEmptyPlayers(categoryName!),
          },
          secondPosition: {
            ...match?.secondPosition,
            players: isNotEmptyArray(match?.secondPosition?.players) ? match?.secondPosition?.players : composeEmptyPlayers(categoryName!),
          },
        }
      })
    } as ITennisResults;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in ResultsSubscription object',
      data: obj
    });
  }
};
